import React from "react";
import {useForm, FormProvider} from "react-hook-form";

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

import * as CustomStyles from '../styles/CustomStyles';
import * as ClientSubconFragment from './ClientSubconFragmentComponent';


function ClientSubconFullRenderer(props) {
    const methods = useForm({
        defaultValues: {
            lSubcontractor: props.subcontractor
        } 
    });

    const handleSubmitData = (data) => {
        const subcontractor = data.lSubcontractor;
        props.saveSubcontractor(subcontractor);
    }

    return(
        <React.Fragment>
            <FormProvider {...methods} > 
            <form onSubmit={methods.handleSubmit( handleSubmitData )} id={'userForm'}>

                <ClientSubconFragment.RenderGeneralSection 
                    currentUsers={props.currentUsers}
                    clients={props.clients}
                    employers={props.employers}
                    worksites={props.worksites}    
                />

                <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                    {/*row*/}
                    <Grid item xs={12} container justifyContent="flex-end" alignItems="flex-end">
                        <Button variant="outlined" type="submit" sx={{ marginRight: 1}}>Salveaza Subcontractor</Button>
                    </Grid>
                </Grid>

            </form>
            </FormProvider>
        </React.Fragment>
    );
}

export default ClientSubconFullRenderer